import { MdInventory, MdWarehouse, MdViewList, MdShoppingCart, MdChecklist, MdCategory, MdSwapHoriz, MdLogout } from "react-icons/md";

const inventario = {
  id: 'inventario-group',
  type: 'group',
  roles: [1,100,110,200,300,400,500],
  breadcrumbs: false,
  children: [
    {
      id: 'inventario',
      title: "Inventario",
      type: 'collapse',
      icon: MdInventory,
      children: [
        {
          id: 'almacenes',
          title: "Almacenes",
          type: 'item',
          breadcrumbs: false,
          icon: MdWarehouse,
          url: '/inventario/almacenes',
          roles: [1,100,110,200]
        },
        {
          id: 'productos',
          title: "Productos",
          type: 'item',
          breadcrumbs: false,
          icon: MdShoppingCart,
          url: '/inventario/productos',
          roles: [1,100,110,200,400,500]
        },
        {
          id: 'lotes',
          title: "Lotes",
          type: 'item',
          breadcrumbs: false,
          icon: MdViewList,
          url: '/inventario/lotes',
          roles: [1,100,110,200]
        },
        {
          id: 'existencias',
          title: "Existencias",
          type: 'item',
          breadcrumbs: false,
          icon: MdInventory,
          url: '/inventario/existencias',
          roles: [1,100,110,200,400]
        },
        // Role 300 (Production) specific items
        {
          id: 'almacenes-produccion',
          title: "Almacenes",
          type: 'item',
          breadcrumbs: false,
          icon: MdWarehouse,
          url: '/inventario/almacenes',
          roles: [300]
        },
        {
          id: 'productos-produccion',
          title: "Productos",
          type: 'item',
          breadcrumbs: false,
          icon: MdShoppingCart,
          url: '/inventario/productos-produccion',
          roles: [300]
        },
        {
          id: 'productos-por-lote',
          title: "Productos por lote",
          type: 'item',
          breadcrumbs: false,
          icon: MdChecklist,
          url: '/inventario/productos-por-lote',
          roles: [300]
        },
        {
          id: 'produccion-existencias-movimientos',
          title: "Movimientos productos",
          type: 'item',
          breadcrumbs: false,
          icon: MdSwapHoriz,
          url: '/inventario/produccion-existencias-movimientos',
          roles: [300]
        },
        {
          id: 'insumos-produccion',
          title: "Insumos",
          type: 'item',
          breadcrumbs: false,
          icon: MdCategory,
          url: '/inventario/insumos-produccion',
          roles: [300]
        },
        {
          id: 'insumos-por-lote',
          title: "Insumos por lote",
          type: 'item',
          breadcrumbs: false,
          icon: MdChecklist,
          url: '/inventario/insumos-por-lote',
          roles: [300]
        },
        {
          id: 'salida-insumo',
          title: "Salida insumo",
          type: 'item',
          breadcrumbs: false,
          icon: MdLogout,
          url: '/inventario/salida-insumo',
          roles: [300]
        },
      ]
    }
  ]
};

export default inventario;
